export const getObject = ({ consolidatedMaterials }) => {
  const obj = {};

  consolidatedMaterials.forEach((m) => {
    // console.log("m", m);

    if (m.tagNumber) {
      const previousState = obj[m.description];
      if (previousState?.description) {
        obj[m.description] = {
          ...previousState,
          quantity: Number(previousState.quantity) + Number(m.quantity),
        };
      } else {
        obj[m.description] = { ...m };
      }
    } else if (m.materialCode) {
      const previousState = obj[m.materialCode];

      if (previousState?.description) {
        obj[m.materialCode] = {
          ...previousState,
          // materialsIds: [...previousState.materialsIds, m.id],
          softwareId: m.softwareId,
          item: previousState.item + ", " + m.item,
          markNo: previousState.markNo + ", " + m.markNo,
          description: m.description,
          quantity: Number(previousState.quantity) + Number(m.quantity),
          totalWtInKgs: Math.round(
            Number(previousState.totalWtInKgs) + Number(m.totalWtInKgs)
          ),
        };
      } else {
        obj[m.materialCode] = { ...m };
      }
    } else {
      const previousState = {
        ...obj[m.description + m.costCode],
        materials: [],
      };

      const PLATE = "plate";
      // const isPlate = m.description.toLowerCase()?.includes(PLATE);
      const isPlate = true;

      let materialLength = 0;

      if (
        previousState?.description &&
        previousState?.costCode === m.costCode
      ) {
        obj[m.description + m.costCode] = {
          ...previousState,
          materials: [...previousState.materials, m],
          softwareId: m.softwareId,
          item: previousState.item + ", " + m.item,

          description: m.description,
          quantity: Number(previousState.quantity) + Number(m.quantity),
          weight: isPlate
            ? Number(previousState.weight) + Number(m?.weight)
            : "",

          length: isPlate
            ? ""
            : previousState?.length +
              Number(m.quantity) * parseMixedNumber(m?.length),
          unit: m.unit,
        };
      } else {
        obj[m.description + m.costCode] = {
          ...m,
          quantity: m.quantity,
          // unit: m.unit,
          length: isPlate
            ? ""
            : parseMixedNumber(m.length) * Number(m.quantity),
          weight: isPlate ? Number(m?.weight) : "",
          materials: [...previousState.materials, m],
        };
      }
    }
  });

  return obj;
};

function parseMixedNumber(str) {
  const [wholePart, fractionPart] = str.split(" ");
  let total = parseInt(wholePart);

  if (fractionPart && fractionPart.includes("/")) {
    const [numerator, denominator] = fractionPart.split("/").map(Number);
    total += numerator / denominator;
  }

  return total;
}

// let quantity, unit;
// if (m.length) {
//   // console.log({ len: m.length });
//   unit = m.length.split(' ').pop();

//   quantity = m.length.match(/\d+\.\d+/)[0];
//   // console.log({ quantity, unit });

//   m = { ...m, unit, quantity };
// } else {
//   m = { ...m, unit: 'No.' };
// }
